import { SplitScreenPage } from "@components/_auth/SplitScreenPage"
import { RequestPasswordResetForm } from "@components/_auth/password-reset/request-password-reset-form"
import { NextPage } from "next"
import React from "react"

const RequestPasswordResetPage: NextPage = () => {
  return (
    <SplitScreenPage
      title="Password reset"
      description="Reset the password for your Viesus Cloud account"
    >
      <RequestPasswordResetForm />
    </SplitScreenPage>
  )
}

export default RequestPasswordResetPage
